<app-data-loader></app-data-loader> <router-outlet></router-outlet>
